import React from "react";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionMedicalInfo({
  historyOfSeizures,
  handleHistoryOfSeizuresChange,
  currentMedications,
  handleCurrentMedicationsChange,
  currentPastInjury,
  handleCurrentPastInjuryChange,
  currentMedicalIllness,
  handleCurrentMedicalIllnessChange,
  allergies,
  handleAllergiesChange,
}) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title-2B">Medical information</div>
      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="History of Seizures"
          value={historyOfSeizures}
          onChange={handleHistoryOfSeizuresChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current Medications"
          value={currentMedications}
          onChange={handleCurrentMedicationsChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current/Past Injury and Any current related mobility issues?"
          value={currentPastInjury}
          onChange={handleCurrentPastInjuryChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current Medical Illness(s)"
          placeholder="e.g., asthma, diabetes, STDs, HIV, Hep B or C"
          value={currentMedicalIllness}
          onChange={handleCurrentMedicalIllnessChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Allergies"
          value={allergies}
          onChange={handleAllergiesChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionMedicalInfo;

